import UserSelect from './dialog'
import OrgSelect from './dialogOrg'
import RoleSelect from './dialogRole'
import mixScale from './mixins/scale'

export default UserSelect

export {
  OrgSelect,
  RoleSelect,
  mixScale
}
